import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  v2ListWorkflowInstructions,
  v2UpsertWorkflowInstruction,
  type UpsertWorkflowInstructionBody,
  type WorkflowInstruction,
} from "@/lib/v2-api/workflow-instructions";
import { workflowInstructionKeys } from "@/query/keys/workflow-instructions";

export function useWorkflowInstructions(workflowId: string | undefined) {
  return useQuery<WorkflowInstruction[]>({
    queryKey: workflowId
      ? workflowInstructionKeys.byWorkflow(workflowId)
      : workflowInstructionKeys.all,
    queryFn: () => v2ListWorkflowInstructions(workflowId as string),
    enabled: Boolean(workflowId),
  });
}

export function useUpsertWorkflowInstruction() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpsertWorkflowInstructionBody) =>
      v2UpsertWorkflowInstruction(body),
    onSuccess: (_result, body) =>
      // Return the promise so the mutation stays pending until the affected
      // list is invalidated (TanStack awaits an onSuccess that returns one).
      queryClient.invalidateQueries({
        queryKey: workflowInstructionKeys.byWorkflow(body.workflowId),
      }),
  });
}
